import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './components/Login';
import Logout from './components/Logout';
import Home from './pages/Home';
import DatasetExplorer from './pages/DatasetExplorer';
import Organizations from './pages/Organizations';
import Programs from './pages/Programs';
import Users from './pages/Users';
import Inventory from './pages/Inventory';
import Assay from './pages/Assay';
import Profile from './pages/Profile';
import ProtectedRoute from './components/ProtectedRoute';
import Configurations from './pages/Configurations';
import IssueDetails from './pages/IssueDetails';
import InventoryDetails from './pages/InventoryDetails';
import Deposition from './pages/Deposition';
import ProcessToken from './pages/ProcessToken';

const App = () => {
  return (
    <Router>
      <Routes>
      <Route path="/datasets" element={<ProtectedRoute><DatasetExplorer /></ProtectedRoute>} />
      <Route path="/process-token" element={<ProcessToken />} />
      <Route path="/" element={<Login />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/logout" element={<Logout />} />
      <Route
          path="/home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
      <Route
          path="/inventory/live-tracking"
          element={
            <ProtectedRoute>
              <Inventory />
            </ProtectedRoute>
          }
        />        
      <Route
          path="/issueDetails/:issue_id" 
          element={
            <ProtectedRoute>
              <IssueDetails />
            </ProtectedRoute>
          }
        />        
      <Route
          path="/inventoryDetails/:compound_lot_id" 
          element={
            <ProtectedRoute>
              <InventoryDetails />
            </ProtectedRoute>
          }
        />        
      <Route
          path="/assay/live-tracking"
          element={
            <ProtectedRoute>
              <Assay />
            </ProtectedRoute>
          }
        />        
      <Route
          path="/admin/organizations"
          element={
            <ProtectedRoute>
              <Organizations />
            </ProtectedRoute>
          }
        />
      <Route
          path="/admin/programs"
          element={
            <ProtectedRoute>
              <Programs />
            </ProtectedRoute>
          }
        />
        <Route
              path="/admin/configurations"
              element={
                <ProtectedRoute>
                  <Configurations />
                </ProtectedRoute>
              }
            />
        <Route
              path="/admin/users"
              element={
                <ProtectedRoute>
                  <Users />
                </ProtectedRoute>
              }
            />
        <Route
              path="/configuration/:type"
              element={
                <ProtectedRoute>
                  <Configurations />
                </ProtectedRoute>
              }
            />

        <Route
          path="/:type/deposition"
          element={
            <ProtectedRoute>
              <Deposition />
            </ProtectedRoute>
          }
        />        

      </Routes>

    </Router>
  );
};

export default App;
